module.exports = __webpack_public_path__ + "img/pro_six_6.5233cf52.jpg";